<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：组件-选择门店
      -->
    <el-dialog title="选择门店" :visible.sync="dialogVisible" @close="cancelFunc" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" width="880px">
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
            
          <div style="display: flex;">
                <el-select @change="provinceChange" v-model="formInline.province_name" filterable  placeholder="请选择省份">
                    <el-option
                            v-for="item in province_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="cityChange" v-model="formInline.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
                    <el-option
                            v-for="item in city_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="regionChange" v-model="formInline.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
                    <el-option
                            v-for="item in region_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
          </div>
          
          <el-form-item label="门店名称"><el-input placeholder="请输入门店名称"  
                style="width: 118px;" v-model="formInline.name"></el-input></el-form-item>
        
           <el-form-item label="联系人/联系方式"><el-input placeholder="请输入联系人/联系方式"  
            style="width: 118px;" v-model="formInline.mobile"></el-input></el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <div style="font-weight: 600;font-size: 16px;">最多选择50个</div>
          <el-table :data="tableData" size="small" border style="width: 100%;height: 400px;overflow-y: auto;" v-loading="loading" 
          @selection-change="handleSelectionChange">
     
            <el-table-column prop="store_name" label="门店名称"></el-table-column>
            <el-table-column prop="linkman" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
            <el-table-column prop="address" label="省市区">

              <template slot-scope="scope">
                {{ scope.row.region.province }} -{{ scope.row.region.city }} -{{ scope.row.region.region }}
              </template>
            </el-table-column>
            
            <el-table-column prop="address" label="地址"></el-table-column>
            
            <el-table-column type="selection" width="45" v-if="multi"></el-table-column>
            <el-table-column label="操作" width="80" v-else>
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="selectUser(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[ 10, 20, 50,200,1000]"
            :page-size="pageSize"
            layout="total, prev,sizes, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
      </div>

    </el-dialog>

  </template>
  
  <script>
  import DataApi from '@/api/data.js';
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*搜索表单对象*/
        formInline: {
            name:"",
            mobile:"",
            province_name:"",
          city_name:"",
          region_name:"",
        },
        /*会员列表*/
        tableData: [],
        /*选中的*/
        multipleSelection: [],
        /*是否显示*/
        dialogVisible: false,
        sure_close:false,


        /* 城市锁 */
        lock_city:true,
        /* 区域锁 */
        lock_region:true,
        province_options:{},
        city_options:{},
        region_options:{},


      };
    },
    props: {
      // 开启弹窗
      is_open: Boolean,
      // 是否多选
      multi: {
        type: Boolean,
        default: () => {
          return true
        }
      },
      selectlist: {
        type: Array,
        default: () => {
          return []
        }
      },
    },

    created() {
      this.dialogVisible = this.is_open;
      this.getAddressList();
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
  
      /*获取数据*/
      getTableList() {
        let self = this;
        self.loading = true;
        let params = self.formInline;
        params.page = self.curPage;
        params.list_rows = self.pageSize;
        DataApi.getStore(params,true).then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.gradeList = data.data.grade;
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
      /*查询*/
      search() {
        this.curPage = 1;
        this.tableData = [];
        this.getTableList();
      },
  
      /*点击确定*/
      confirmFunc() {
        let params = this.multipleSelection;

        if( this.multipleSelection.length > 50){
          this.$message.error('最多只能选择50家门店哦');
          return;
        }
        this.sure_close = true;
        this.emitFunc( params);
      },
  
      /*关闭弹窗*/
      cancelFunc(e) {

        if(!this.sure_close){
          this.emitFunc();
        }
       
      },
  
      /*发送事件*/
      emitFunc(e) {
        this.dialogVisible = false;
     
        if (e && typeof e != 'undefined') {
          this.$emit('closex', {
            type: 'success',
            params: e
          });
        } else {
          this.$emit('closex', {
            type: 'error'
          });
        }
      },
  
      /*监听单选按钮选中事件*/
      selectUser(val) {
        this.multipleSelection = val;
        this.confirmFunc();
      },
  
      /*选择门店*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },


              /* 省份获取 */
       getAddressList(){
                let self = this;
                UserApi.provinceList('',true)
                    .then(data => {
                        self.province_options = data.data.list;
                        console.log(self.province_options)
                    })
                    .catch(error => {

                    });
            },
            /* 市列表 */
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                UserApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            /* 区列表 */
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                UserApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            /* 选择省 */
            provinceChange(selVal){
                let self = this
                self.formInline.province_name = selVal.name
                self.formInline. province_id = selVal.id
                self.formInline.city_name = ""
                self.formInline.city_id = ""
                self.formInline.region_id = ""
                console.log(self.lock_city)
                self.lock_city = false
                console.log(self.lock_city)
                if (!self.lock_region){
                    self.lock_region = true
                    self.formInline.region_name = ""
                }
                self.cityList(selVal.id)
            },
            /* 选择市 */
            cityChange(selVal){
                let self = this
                self.formInline.city_name = selVal.name
                self.formInline.city_id = selVal.id
                self.formInline.region_name = ""
                self.formInline.region_id = ""
                if (self.lock_region){
                    self.lock_region = false
                }
                self.regionList(selVal.id);
            },
            /* 选择区 */
            regionChange(selVal){
                let self = this
                self.formInline.region_name = selVal.name
                self.formInline.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
                console.log(self.formInline.region_name)
            },
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/store/Stores.vue